var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{attrs:{"src":require('@/assets/' + _vm.source),"alt":_vm.altText},on:{"click":function($event){_vm.action ? _vm.action() : null}}})}
var staticRenderFns = []

export { render, staticRenderFns }